import React, { Component } from 'react';
import {Col, Panel, Image } from 'react-bootstrap';
import StartFlag from 'src/img/Start Icon.png';
import EndFlag from 'src/img/End Icon.png'
import HAIcon from 'src/img/Accel Icon.png';
import HBIcon from 'src/img/Braking Icon.png';
import CRIcon from 'src/img/Cornering Icon.png';
import 'src/css/TripMapMarkerInfo.css';
import 'src/i18n';
import { withTranslation, Trans } from 'react-i18next';

class TripMapMarkerInfo extends Component {

    constructor() {
        super();

        this.state = {
            windowSize: window.parent.screen.width,
        }
        this.updateWindowSize = this.updateWindowSize.bind(this);
    }

    // 画面サイズの更新
    updateWindowSize() {
        this.setState({ windowSize: window.parent.screen.width });
    }

    componentDidMount() {
        // 画面サイズ変更イベントを登録
        window.addEventListener("resize", this.updateWindowSize);
    }

    componentWillUnmount() {
        // イベントを削除
        window.removeEventListener("resize", this.updateWindowSize);
    }

    render() {
        const {t} = this.props;
        return (
            <div id="map-icon-parent">
                <Image className="markerFlag" src={CRIcon} id="CR_ICON"/> 
                <div id="CR">
                    <Trans i18nKey="TripDetail.HarshCornering">
                        Harsh<br/>Cornering
                    </Trans>
                </div>
                <Image className="markerFlag" src={HAIcon} id="HA_ICON"/> 
                <div id="HA">
                    <Trans i18nKey="TripDetail.HardAcceleration">
                        Hard<br/>Acceleration
                    </Trans>
                </div>
                <Image className="markerFlag" src={HBIcon} id="HB_ICON"/>
                <div id="HB">
                    <Trans i18nKey="TripDetail.HarshBraking">
                        Harsh<br/>Braking
                    </Trans>
                </div>
                <Image className="markerFlag" src={StartFlag} id="TripStart_ICON"/> 
                <div id="TripStart">{t('TripDetail.TripStart')}</div>
                <Image className="markerFlag" src={EndFlag} id="TripEnd_ICON"/> 
                <div id="TripEnd">{t('TripDetail.TripEnd')}</div>
                
                <div className='mini-div' />
            </div>
        );
    }
}

export default withTranslation()(TripMapMarkerInfo);


// WEBPACK FOOTER //
// ./src/component/TripReportDetail/TripMapMarkerInfo.js